// extracted by mini-css-extract-plugin
export var categoryIcon = "_da-5";
export var connectorContainer = "_da-1";
export var connectorLine = "_da-0";
export var minHeight0 = "_da-6";
export var relativeUnitValueSelector = "_da-2";
export var trifoldSelectorBody = "_da-4";
export var trifoldSelectorList = "_da-3";